const t = {
  name: "Brunei",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9998 7.10002V6H14.9998V4H12.9998V2H10.9998V4H8.99984V6H10.9998V7.10002C8.7176 7.56329 6.99984 9.58104 6.99984 12C6.99984 14.7614 9.23842 17 11.9998 17C14.7613 17 16.9998 14.7614 16.9998 12C16.9998 9.58104 15.2821 7.56329 12.9998 7.10002ZM11.9998 9C13.6567 9 14.9998 10.3431 14.9998 12C14.9998 13.6569 13.6567 15 11.9998 15C10.343 15 8.99984 13.6569 8.99984 12C8.99984 10.3431 10.343 9 11.9998 9Z" fill="currentColor"/>
<path d="M18.3471 18.5271L19.0542 17.82L17.64 16.4058L16.9329 17.1129C15.6621 18.3837 13.9132 19.17 11.97 19.17C10.0542 19.17 8.32196 18.4015 7.04969 17.1555L6.33523 16.4558L4.93588 17.8848L5.65034 18.5844C7.27807 20.1785 9.50587 21.17 11.97 21.17C14.4668 21.17 16.7179 20.1563 18.3471 18.5271Z" fill="currentColor"/>
<path d="M22.3415 8.55245L20.9998 11.2357V14.9997H18.9998V10.7636L20.5526 7.65802L22.3415 8.55245Z" fill="currentColor"/>
<path d="M2.99984 11.2361L1.6582 8.55281L3.44706 7.65839L4.99984 10.764V15H2.99984V11.2361Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Brunei
};
